__turbopack_context__.v({
  "container": "PlansPanel-module-scss-module__6DBpwq__container",
  "loaderWrapper": "PlansPanel-module-scss-module__6DBpwq__loaderWrapper",
  "plansCount1": "PlansPanel-module-scss-module__6DBpwq__plansCount1",
  "plansCount2": "PlansPanel-module-scss-module__6DBpwq__plansCount2",
});
